export const clientId = "0eae5db41d2a450bbd04e253c141d666";
export const clientSecret = "e4684383e7434dbaabafced70a23f851";
export const refreshToken =
  "AQC_neCGIkQ8Qo1tzgKgEEQ28lAL9FbPEwbQCLUeFDO4Ou70FbfQlcRXQ32348UjWim2yjM-s4UhnTEQBe-D-qKPFsAWYj9dqUbPOF8JmFe2QKECPVznSKduzCsRb7efJFk";
